import { render } from "./clients_list.vue?vue&type=template&id=b9b25b1c"
import script from "./clients_list.vue?vue&type=script&lang=js"
export * from "./clients_list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__